import { render } from "./Photos.vue?vue&type=template&id=b89027ea&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=b89027ea&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_genba/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89027ea"]])

export default __exports__